import styled from 'styled-components';

export const ProjectsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #010606;
`;

export const ProjectsWrapper = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 72px 50px;

  @media screen and (max-width: 786px) {
    padding: 48px 20px;
  }
`;

export const ProjectsContent = styled.div`
  display: flex;
  overflow-x: auto;
`;

export const ProjectTitle = styled.h2`
  position: absolute;
  bottom: 0;
  font-size: 1rem;
  margin: 0;
  padding: 12px;
  background-color: #fff;
  text-align: center;
  width: 100%;
  display: none;
`;

export const ProjectImg = styled.img`
  display: block;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  border: 1px solid #010606;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  object-fit: cover;
  aspect-ratio: 3 / 4;
`;

export const ProjectCard = styled.div`
  min-width: 280px;
  width: 280px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  color: #010606;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease-in-out;

  & + & {
    margin-left: 32px;
  }

  &:hover {
    ${ProjectImg} {
      filter: brightness(55%);
      transform: scale(1.1);
    }

    ${ProjectTitle} {
      display: block;
    }
  }

  @media screen and (max-width: 786px) {
    min-width: 300px;
    width: 300px;
  }
`;

export const ProjectsH1 = styled.h1`
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 24px;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const ProjectsP = styled.p`
  font-size: 1rem;
`;

export const VideosGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 48px;
  grid-row-gap: 48px;
  margin-top: 72px;

  @media screen and (max-width: 786px) {
    grid-template-columns: 1fr;
    grid-column-gap: 0;
    grid-row-gap: 24px;
    margin-top: 48px;
  }
`;

export const IframeContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;

    @media screen and (max-width: 786px) {
      border-radius: unset;
    }
  }
`;
